import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { Observable, of } from "rxjs";
import { catchError, map } from "rxjs/operators";
import * as Enums from "src/app/enums";

export type LogoSize = 1 | 2 | 3;

/**
 * classification_id:
 * 1 = logo do login
 * 2 = logo pequeno do sidebar
 * 3 = logo do sidebar
 */
const logoBaseUrl = `${Enums.VARS.API_BASE_URL}open/systemConfigs/getLogo`;

@Injectable({ providedIn: "root" })
export class LogoService {
  constructor(private http: HttpClient) {}

  private getLogoUrl(size: LogoSize): string {
    return `${logoBaseUrl}?classification_id=${size}`;
  }

  getLogo$(size: LogoSize = 1): Observable<string> {
    const url = this.getLogoUrl(size);
    return this.http.get<any>(url).pipe(
      map((response) => {
        if (response.status && response.data && response.data.url) {
          return response.data.url;
        } else {
          throw new Error(`Resposta inválida da API para logo ${size}`);
        }
      }),
      catchError(() => {
        // Em caso de erro, retorna a URL da API
        return of(url);
      })
    );
  }
}
